import { ExtraBenefitClaimService } from "../../src/services/ExtraBenefitClaimService";
import { ExtraBenefitClaimConstants } from "../constants/ExtraBenefitClaimConstants";
import { alertActions } from ".";

export const ExtraBenefitClaimActions = {
  getAll,
  getSubAll,
  createCatagory,
  updateCategory,
  openDialog,
  inActiveRow,
  inActiveRow2,
  onHideShow,
  onHideShow2,
  loadingData,
  loadingData2,
  onHideShowIsActive,
  onHideShowIsActive2,
  getCategoryDDL,
  createSubCategory,
  SubUpdateCategory,
  getSubCategoryDDL,
  approveUser,
  RecivedGift,
  DispatchGift

};

function approveUser(ApprovedBy,id) {
  
  var data = {
    ApprovedBy: ApprovedBy, id:id
  };
  return (dispatch) => {
    dispatch(request());

    ExtraBenefitClaimService.approveUser(ApprovedBy,id).then(

      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === 200) {
            dispatch(success(data));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === 400) {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_FAILURE, error };
  }
}

function RecivedGift(RecievdBy,id) {
  
  var data = {
     RecievdBy:  RecievdBy, id:id
  };
  return (dispatch) => {
    dispatch(request());

    ExtraBenefitClaimService.RecivedGift(RecievdBy,id).then(

      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === 200) {
            dispatch(success(data));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === 409) {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_FAILURE, error };
  }
}


function DispatchGift(DispatchBy,id) {
  
  var data = {
     DispatchBy:  DispatchBy, id:id
  };
  return (dispatch) => {
    dispatch(request());

    ExtraBenefitClaimService.DispatchGift(DispatchBy,id).then(

      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === 200) {
            dispatch(success(data));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === 409) {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_FAILURE, error };
  }
}

function getAll(data) {
  return (dispatch) => {
    dispatch(request());
    ExtraBenefitClaimService.getCategory(data).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitClaimConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: ExtraBenefitClaimConstants.GETALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.GETALL_FAILURE, error };
  }
}


function getSubAll(data) {
  return (dispatch) => {
    dispatch(request());
    ExtraBenefitClaimService.getSubCategory(data).then(
      (response) => {
        dispatch(loadingData2(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData2(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitClaimConstants.GETSUBALL_REQUEST };
  }
  function success(datas) {
    return { type: ExtraBenefitClaimConstants.GETSUBALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.GETSUBALL_FAILURE, error };
  }
}

function createCatagory(data,obj) {
  return (dispatch) => {
    dispatch(request(data));
    ExtraBenefitClaimService.createCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            
            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(getAll(obj));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitClaimConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: ExtraBenefitClaimConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.CREATE_FAILURE, error };
  }
}

function createSubCategory(data) {
  return (dispatch) => {
    dispatch(request(data));
    ExtraBenefitClaimService.createSubCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            ;
            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitClaimConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: ExtraBenefitClaimConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.CREATE_FAILURE, error };
  }
}

function updateCategory(data) {
  return (dispatch) => {
    dispatch(request(data));
    ExtraBenefitClaimService.updateCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          ;
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitClaimConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: ExtraBenefitClaimConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.UPDATE_FAILURE, error };
  }
}

function SubUpdateCategory(data) {
  return (dispatch) => {
    dispatch(request(data));
    ExtraBenefitClaimService.SubUpdateCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          ;
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitClaimConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: ExtraBenefitClaimConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.UPDATE_FAILURE, error };
  }
}
function inActiveRow(category, isActive) {
  var data = {
    CategoryId: category,
    IsActive: isActive,
  };
  return (dispatch) => {
    dispatch(request());

    ExtraBenefitClaimService.inActiveRow(category, isActive).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE_FAILURE, error };
  }
}

function inActiveRow2(category, isActive) {
  var data = {
    SubCatId: category,
    IsActive: isActive,
  };
  return (dispatch) => {
    dispatch(request());

    ExtraBenefitClaimService.inActiveRow2(category, isActive).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitClaimConstants.ISACTIVE2_REQUEST };
  }
  function success(data) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE2_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.ISACTIVE2_FAILURE, error };
  }
}

function onHideShow(isbool) {
  return {
    type: ExtraBenefitClaimConstants.DIALOG_REQUEST,
    isbool,
  };
}


function onHideShow2(isbool) {
  return {
    type: ExtraBenefitClaimConstants.DIALOG_REQUEST2,
    isbool,
  };
}

function loadingData(isbool) {
  return {
    type: ExtraBenefitClaimConstants.LOADING_REQUEST,
    isbool,
  };
}
function loadingData2(isbool) {
  return {
    type: ExtraBenefitClaimConstants.LOADING_REQUEST2,
    isbool,
  };
}
function onHideShowIsActive(isbool) {
  return {
    type: ExtraBenefitClaimConstants.DIALOG_ISACTIVE_REQUEST,
    isbool,
  };
}
function onHideShowIsActive2(isbool) {
  return {
    type: ExtraBenefitClaimConstants.DIALOG_ISACTIVE_REQUEST2,
    isbool,
  };
}

function openDialog(data) {
  return {
    type: ExtraBenefitClaimConstants.OPEN_DIALOG_REQUEST,
    data,
  };
}

function getCategoryDDL(data, flag) {
  return (dispatch) => {
    dispatch(request());
    ExtraBenefitClaimService.fetchCategoryDLL(data).then(
      (response) => {
        

        // if (flag == 1) {
        //   response.ResponseData.splice(0, 0, { label: "All", value: "0" });
        // }
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitClaimConstants.GETCATEGORYDDL_REQUEST };
  }
  function success(datas) {
    return { type: ExtraBenefitClaimConstants.GETCATEGORYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.GETCATEGOYRDDL_FAILURE, error };
  }
}


function getSubCategoryDDL(data) {
  return (dispatch) => {
    dispatch(request());
    ExtraBenefitClaimService.fetchSubCategoryDLL(data).then(
      (response) => {

        // if (flag == 1) {
        //   response.ResponseData.splice(0, 0, { label: "All", value: "0" });
        // }
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitClaimConstants.GETSUBCATEGORYDDL_REQUEST };
  }
  function success(datas) {
    return { type: ExtraBenefitClaimConstants.GETSUBCATEGORYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ExtraBenefitClaimConstants.GETSUBCATEGORYDDL_FAILURE, error };
  }
}